import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Spinner } from '../control/DmControlPrimitives';
import type { LiveNotesStatus } from './liveNotesStatus';

interface NotesSyncStatusProps {
    status: LiveNotesStatus;
}

function NotesSyncStatus({ status }: NotesSyncStatusProps) {
    if (status === 'checking') {
        return (
            <span role="status" className="inline-flex items-center gap-2 text-xs text-gray-500">
                <Spinner className="h-3.5 w-3.5 text-[#007E87]" />
                Checking DM…
            </span>
        );
    }
    if (status === 'unavailable') {
        return (
            <span
                role="status"
                className="inline-flex items-center gap-1.5 text-xs text-yellow-700"
            >
                <ExclamationTriangleIcon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
                {"Couldn't reach DM — showing last synced notes"}
            </span>
        );
    }
    return null;
}

export { NotesSyncStatus };
